<div class="message-block">
  <div class="customer-message-container">
    <div class="customer-message" [innerHTML]="msg.body | convertLinkable | safeHtml"></div>
    <div>
      <strong>{{msg.displayName}}</strong>
      <div>{{msg.timestamp | date : 'EE, MMM d, h:mm a'}}</div>
    </div>
  </div>
</div>
